// src/views/areasComuns/AreaComumModal.jsx
import React, { useState, useEffect } from "react";
import contasContabeisService from "../../services/contasContabeisService";

const DIAS_SEMANA = [
  {v:"0",l:"Dom"},{v:"1",l:"Seg"},{v:"2",l:"Ter"},
  {v:"3",l:"Qua"},{v:"4",l:"Qui"},{v:"5",l:"Sex"},{v:"6",l:"Sáb"},
];

const EMPTY = {
  nmArea:"", descricao:"", capacidade:"", tpPeriodo:"DiaInteiro",
  hrInicio:"08:00", hrFim:"22:00",
  diasPermitidos:"0,1,2,3,4,5,6",
  vlrLocacao:"0.00", vlrCaucao:"0.00", vlrTaxaCancelamento:"0.00",
  limiteReservasMes:"0", diasAntecedencia:"1", diasCancelamento:"2",
  duracaoMinutos:"60", idContaContabil:"", situacao:"Ativa", observacao:"", diasMaxAntecedencia:"90",
};

export default function AreaComumModal({ show, onClose, onSave, editData, saving=false, idCondominio, condominioNome="" }) {
  const isEdit = !!editData?.id;
  const [form, setForm]     = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [tab, setTab]       = useState("dados");
  const [contasContabeis, setContasContabeis] = useState([]);

  useEffect(() => {
    if (!idCondominio) return;
    contasContabeisService.listar({ idCondominio, situacao:"ativo", natureza:"Analitica" })
      .then(r => setContasContabeis(r.data||[])).catch(()=>{});
  }, [idCondominio]);

  useEffect(() => {
    if (!show) return;
    setForm(editData ? { ...EMPTY, ...editData } : { ...EMPTY });
    setErrors({}); setTab("dados");
  }, [show, editData]);

  const set = (f,v) => { setForm(p=>({...p,[f]:v})); setErrors(p=>({...p,[f]:undefined})); };

  const toggleDia = (dia) => {
    const dias = form.diasPermitidos.split(",").filter(Boolean);
    const novo = dias.includes(dia) ? dias.filter(d=>d!==dia) : [...dias,dia].sort();
    set("diasPermitidos", novo.join(","));
  };

  const validate = () => {
    const e = {};
    if (!form.nmArea.trim()) e.nmArea = "Nome da área é obrigatório";
    if (form.tpPeriodo==="Horario" && (!form.hrInicio||!form.hrFim)) e.hrInicio = "Horários obrigatórios";
    setErrors(e); if(Object.keys(e).length){setTab("dados");return false;} return true;
  };

  const fmtMoeda = v => Number(v||0).toLocaleString("pt-BR",{style:"currency",currency:"BRL"});

  if (!show) return null;

  const diasSel = form.diasPermitidos.split(",").filter(Boolean);
  const tabs = [
    { id:"dados",    label:"Dados Gerais",   icon:"bi-door-open"   },
    { id:"valores",  label:"Valores e Conta", icon:"bi-cash-coin"  },
    { id:"regras",   label:"Regras / Regulamento", icon:"bi-file-text" },
  ];

  return (
    <div className="modal fade show d-block" style={{background:"rgba(0,0,0,.55)"}} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          {/* Header */}
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{width:38,height:38,background:"rgba(255,255,255,.15)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className="bi bi-door-open" style={{fontSize:18,color:"#fff"}}/>
              </div>
              <div>
                <h5 className="modal-title mb-0">{isEdit?"Editar Área":"Nova Área Comum"}</h5>
                <small style={{color:"rgba(255,255,255,.6)",fontSize:12}}>{condominioNome}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose}/>
          </div>

          {/* Tabs */}
          <div style={{background:"var(--primary)",padding:"0 24px"}}>
            <ul className="nav nav-tabs border-0" style={{gap:4}}>
              {tabs.map(t=>(
                <li key={t.id} className="nav-item">
                  <button className={`nav-link border-0 d-flex align-items-center gap-2 ${tab===t.id?"active":""}`}
                    style={{background:tab===t.id?"#fff":"transparent",color:tab===t.id?"var(--primary)":"rgba(255,255,255,.7)",
                      borderRadius:"6px 6px 0 0",fontFamily:"Poppins,sans-serif",fontSize:13,fontWeight:500,padding:"10px 18px"}}
                    onClick={()=>setTab(t.id)}>
                    <i className={`bi ${t.icon}`}/>{t.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body">

            {/* ── ABA DADOS GERAIS ── */}
            {tab==="dados" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-door-open"/> Identificação</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Nome da Área <span className="required-mark">*</span></label>
                      <input className={`form-control ${errors.nmArea?"is-invalid":""}`}
                        value={form.nmArea} onChange={e=>set("nmArea",e.target.value)}
                        placeholder="Ex: Churrasqueira 1, Salão de Festas, Piscina..."/>
                      {errors.nmArea&&<div className="invalid-feedback">{errors.nmArea}</div>}
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Capacidade (pessoas)</label>
                      <input className="form-control" type="number" min="1" value={form.capacidade}
                        onChange={e=>set("capacidade",e.target.value)}/>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label">Situação</label>
                      <select className="form-select" value={form.situacao} onChange={e=>set("situacao",e.target.value)}>
                        <option value="Ativa">Ativa</option>
                        <option value="Inativa">Inativa</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label">Descrição</label>
                      <textarea className="form-control" rows={2} value={form.descricao}
                        onChange={e=>set("descricao",e.target.value)}
                        placeholder="Descreva a área, itens disponíveis, capacidade..."/>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-calendar-week"/> Disponibilidade</div>
                  <div className="row g-3">
                    <div className="col-md-3">
                      <label className="form-label">Tipo de Período</label>
                      <select className="form-select" value={form.tpPeriodo} onChange={e=>set("tpPeriodo",e.target.value)}>
                        <option value="DiaInteiro">Dia Inteiro</option>
                        <option value="Horario">Por Horário</option>
                      </select>
                    </div>
                    {form.tpPeriodo==="Horario" && <>
                      <div className="col-md-2">
                        <label className="form-label">Horário Início <span className="required-mark">*</span></label>
                        <input type="time" className={`form-control ${errors.hrInicio?"is-invalid":""}`}
                          value={form.hrInicio} onChange={e=>set("hrInicio",e.target.value)}/>
                        {errors.hrInicio&&<div className="invalid-feedback">{errors.hrInicio}</div>}
                      </div>
                      <div className="col-md-2">
                        <label className="form-label">Horário Fim</label>
                        <input type="time" className="form-control" value={form.hrFim}
                          onChange={e=>set("hrFim",e.target.value)}/>
                      </div>
                    </>}
                    <div className="col-md-2">
                      <label className="form-label" title="Mínimo de dias entre HOJE e a data da reserva">
                        Antecedência Mínima (dias)
                      </label>
                      <input className="form-control" type="number" min="0" value={form.diasAntecedencia}
                        onChange={e=>set("diasAntecedencia",e.target.value)}/>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>0 = mesmo dia</small>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label" title="Máximo de dias permitido entre HOJE e a data da reserva (janela de agendamento)">
                        Antecedência Máxima (dias)
                      </label>
                      <input className="form-control" type="number" min="1" value={form.diasMaxAntecedencia||"90"}
                        onChange={e=>set("diasMaxAntecedencia",e.target.value)}/>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>Janela máxima de agendamento</small>
                    </div>
                    <div className="col-md-2">
                      <label className="form-label" title="Prazo mínimo (em dias) entre HOJE e a data da reserva para permitir cancelamento sem multa">
                        Antecedência p/ Cancelar (dias)
                      </label>
                      <input className="form-control" type="number" min="0" value={form.diasCancelamento||"2"}
                        onChange={e=>set("diasCancelamento",e.target.value)}/>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>Prazo mínimo para cancelar</small>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label" title="Quantas reservas a mesma unidade pode fazer no mesmo mês">
                        Limite reservas/mês por unidade
                      </label>
                      <input className="form-control" type="number" min="0" value={form.limiteReservasMes}
                        onChange={e=>set("limiteReservasMes",e.target.value)}/>
                      <small style={{fontSize:11,color:"var(--gray-400)"}}>0 = sem limite</small>
                    </div>

                    <div className="col-12">
                      <label className="form-label">Dias Permitidos</label>
                      <div style={{display:"flex",gap:8,flexWrap:"wrap",marginTop:4}}>
                        {DIAS_SEMANA.map(d=>(
                          <button key={d.v} type="button"
                            style={{padding:"6px 16px",borderRadius:20,fontSize:13,fontWeight:600,cursor:"pointer",border:"2px solid",
                              borderColor:diasSel.includes(d.v)?"var(--primary)":"var(--gray-300)",
                              background:diasSel.includes(d.v)?"var(--primary)":"#fff",
                              color:diasSel.includes(d.v)?"#fff":"var(--gray-500)"}}
                            onClick={()=>toggleDia(d.v)}>
                            {d.l}
                          </button>
                        ))}
                      </div>
                    </div>

                    {/* Resumo das regras */}
                    <div className="col-12">
                      <div style={{background:"var(--bg-highlight)",border:"1px solid #BFDBFE",borderRadius:8,padding:"12px 14px",fontSize:12,color:"#1E3A8A"}}>
                        <strong style={{display:"block",marginBottom:6,fontSize:12.5}}>
                          <i className="bi bi-info-circle me-1"/>Resumo das regras de agendamento
                        </strong>
                        <ul style={{margin:0,paddingLeft:18,lineHeight:1.7}}>
                          <li>Reservas com no mínimo <strong>{form.diasAntecedencia||0}</strong> e no máximo <strong>{form.diasMaxAntecedencia||90}</strong> dia(s) de antecedência.</li>
                          <li>Cancelamento permitido até <strong>{form.diasCancelamento||2}</strong> dia(s) antes da reserva (depois disso, taxa de cancelamento aplicada).</li>
                          <li>Funcionamento: <strong>{form.tpPeriodo==="Horario"?`das ${form.hrInicio||"--:--"} às ${form.hrFim||"--:--"}`:"dia inteiro"}</strong>{form.duracaoMinutos&&form.tpPeriodo==="Horario"?` (slots de ${form.duracaoMinutos} min)`:""}.</li>
                          <li>Dias permitidos: <strong>{diasSel.length===7?"todos os dias":diasSel.map(d=>DIAS_SEMANA.find(x=>x.v===d)?.l).join(", ")||"(nenhum)"}</strong>.</li>
                          {parseInt(form.limiteReservasMes||0)>0 && <li>Limite por unidade: <strong>{form.limiteReservasMes}</strong> reserva(s) por mês.</li>}
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* ── ABA VALORES ── */}
            {tab==="valores" && (
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-cash-coin"/> Valores e Conta Contábil</div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">Valor da Locação (R$)</label>
                    <div className="input-group">
                      <span className="input-group-text">R$</span>
                      <input className="form-control" type="number" step="0.01" min="0" value={form.vlrLocacao}
                        onChange={e=>set("vlrLocacao",e.target.value)}/>
                    </div>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Valor da Caução (R$)</label>
                    <div className="input-group">
                      <span className="input-group-text">R$</span>
                      <input className="form-control" type="number" step="0.01" min="0" value={form.vlrCaucao}
                        onChange={e=>set("vlrCaucao",e.target.value)}/>
                    </div>
                    <small style={{fontSize:11,color:"var(--gray-400)"}}>Lançado separado — devolvido após evento</small>
                  </div>
                  <div className="col-md-3">
                    <label className="form-label">Taxa de Cancelamento (R$)</label>
                    <div className="input-group">
                      <span className="input-group-text">R$</span>
                      <input className="form-control" type="number" step="0.01" min="0" value={form.vlrTaxaCancelamento}
                        onChange={e=>set("vlrTaxaCancelamento",e.target.value)}/>
                    </div>
                    <small style={{fontSize:11,color:"var(--gray-400)"}}>Cobrada ao cancelar após confirmação</small>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Conta Contábil de Receita</label>
                    <select className="form-select" value={form.idContaContabil} onChange={e=>set("idContaContabil",e.target.value)}>
                      <option value="">— Sem vínculo —</option>
                      {contasContabeis.filter(c=>["ReceitaOrdinaria","ReceitaExtraordinaria","Outro"].includes(c.tpConta)).map(c=>(
                        <option key={c.id} value={c.id}>{c.classificacaoContabil} — {c.descConta}</option>
                      ))}
                    </select>
                  </div>
                </div>

                {/* Resumo financeiro */}
                <div style={{background:"var(--bg-success-soft)",borderRadius:8,padding:"14px 18px",marginTop:16,display:"flex",gap:24,flexWrap:"wrap",alignItems:"center"}}>
                  <div>
                    <div style={{fontSize:11,color:"#166534",fontWeight:600}}>LOCAÇÃO</div>
                    <div style={{fontSize:18,fontWeight:700,color:"var(--primary)"}}>{fmtMoeda(form.vlrLocacao)}</div>
                  </div>
                  {parseFloat(form.vlrCaucao||0)>0 && <>
                    <div style={{fontSize:20,color:"var(--gray-300)"}}>+</div>
                    <div>
                      <div style={{fontSize:11,color:"#854D0E",fontWeight:600}}>CAUÇÃO</div>
                      <div style={{fontSize:18,fontWeight:700,color:"#C2410C"}}>{fmtMoeda(form.vlrCaucao)}</div>
                    </div>
                  </>}
                  <div style={{fontSize:20,color:"var(--gray-300)"}}>=</div>
                  <div>
                    <div style={{fontSize:11,color:"#166534",fontWeight:600}}>TOTAL COBRADO</div>
                    <div style={{fontSize:20,fontWeight:700,color:"#166534"}}>
                      {fmtMoeda(parseFloat(form.vlrLocacao||0)+parseFloat(form.vlrCaucao||0))}
                    </div>
                  </div>
                  {parseFloat(form.vlrTaxaCancelamento||0)>0 && (
                    <div style={{marginLeft:"auto",background:"var(--bg-warning-soft)",borderRadius:8,padding:"8px 14px"}}>
                      <div style={{fontSize:11,color:"#854D0E",fontWeight:600}}>TAXA CANCELAMENTO</div>
                      <div style={{fontSize:16,fontWeight:700,color:"#C2410C"}}>{fmtMoeda(form.vlrTaxaCancelamento)}</div>
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* ── ABA REGRAS ── */}
            {tab==="regras" && (
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-file-text"/> Regulamento e Observações</div>
                <div className="row g-3">
                  <div className="col-12">
                    <label className="form-label">Regulamento de Uso</label>
                    <textarea className="form-control" rows={8} value={form.regulamento}
                      onChange={e=>set("regulamento",e.target.value)}
                      placeholder={`Ex:\n1. A reserva deve ser feita com 24h de antecedência.\n2. O condômino é responsável pela limpeza após o uso.\n3. Barulho permitido até as 22h.\n4. Capacidade máxima: ${form.capacidade||"—"} pessoas.`}/>
                    <small style={{fontSize:11,color:"var(--gray-400)"}}>Esse texto será exibido ao condômino ao realizar a reserva</small>
                  </div>
                  <div className="col-12">
                    <label className="form-label">Observações Internas</label>
                    <textarea className="form-control" rows={3} value={form.observacao}
                      onChange={e=>set("observacao",e.target.value)}
                      placeholder="Observações para uso interno da administração..."/>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div style={{fontSize:12,color:"var(--gray-400)"}}>
              <i className="bi bi-asterisk me-1" style={{color:"#ef4444",fontSize:9}}/>Campos obrigatórios
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}>
                <i className="bi bi-x-circle"/> Cancelar
              </button>
              <button className="btn btn-primary" onClick={()=>{ if(validate()) onSave({...form,id:editData?.id}); }} disabled={saving}>
                {saving
                  ? <><span className="spinner-border spinner-border-sm me-2"/>Salvando...</>
                  : <><i className="bi bi-check-circle"/> {isEdit?"Salvar Alterações":"Cadastrar"}</>
                }
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
